import Vue from 'vue'

const miniPictureInstance = Vue.extend(require('./miniPicture.vue').default);
let instance = null

let getInstance = () => {
  return new miniPictureInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
}

let miniPicture = (src) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  instance.open(src)
}

export default miniPicture
